var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24365 0.30542C6.44084 0.10986 6.70825 0 6.98708 0C7.2659 0 7.53332 0.10986 7.73051 0.30542L13.679 6.20652C13.7794 6.30275 13.8595 6.41786 13.9146 6.54513C13.9697 6.67239 13.9987 6.80928 14 6.94778C14.0012 7.08629 13.9746 7.22365 13.9217 7.35185C13.8688 7.48005 13.7907 7.59652 13.692 7.69447C13.5933 7.79241 13.4759 7.86987 13.3467 7.92232C13.2174 7.97477 13.079 8.00116 12.9393 7.99996C12.7997 7.99876 12.6617 7.96998 12.5334 7.91531C12.4052 7.86064 12.2891 7.78117 12.1921 7.68154L6.98708 2.51794L1.78203 7.68154C1.58371 7.87156 1.31809 7.9767 1.04239 7.97432C0.766681 7.97195 0.502945 7.86224 0.307984 7.66883C0.113023 7.47542 0.00243378 7.21379 3.8147e-05 6.94028C-0.00235748 6.66677 0.10363 6.40326 0.295174 6.20652L6.24365 0.30542Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.8d0c3a219b5873695931abb13788a204.svg";
export { ForwardRef as ReactComponent };